export default __webpack_public_path__ + "static/media/shop-now.52a62559.jpg";